import { styled } from '../../../core/theme/styled';

export const Divider = styled.div`
  width: 1px;
  background-color: ${({ theme }) => theme.configuration.strokeColor};
`;
